const SEO = [
	{
		page: "home",
		description:
			"Soumik Saha — Software Engineer & Full-Stack Developer at TCS. Specialized in Java, Spring Boot, REST APIs, PostgreSQL, and modern web application development.",
		keywords: [
			"Soumik Saha",
			"Software Engineer",
			"Backend Engineer",
			"Java Developer",
			"Spring Boot",
			"Full-Stack Developer",
			"TCS",
			"Kolkata",
		],
	},

	{
		page: "about",
		description:
			"Learn about Soumik Saha's engineering background, enterprise software experience at TCS, backend engineering focus with Java & Spring Boot, and learning roadmap.",
		keywords: [
			"Soumik Saha",
			"About Soumik Saha",
			"TCS Systems Engineer",
			"Java Backend Engineer",
			"Spring Boot Developer",
			"Kolkata Software Engineer",
		],
	},

	{
		page: "projects",
		description:
			"Explore full-stack and backend software projects built by Soumik Saha, including SkyFleet flight booking platform and PulseConnect real-time messaging application.",
		keywords: [
			"Soumik Saha Projects",
			"SkyFleet",
			"PulseConnect",
			"Java Spring Boot Projects",
			"React Full-Stack Projects",
			"PostgreSQL Applications",
		],
	},

	{
		page: "articles",
		description:
			"Technical articles and insights by Soumik Saha on full-stack development, database query optimization, system design, and software engineering practices.",
		keywords: [
			"Soumik Saha Articles",
			"Software Engineering Blog",
			"Spring Boot Insights",
			"Database Optimization",
			"Web Development Trends",
		],
	},

	{
		page: "contact",
		description:
			"Get in touch with Soumik Saha for software engineering opportunities, technical discussions on backend development, system design, and product building.",
		keywords: [
			"Contact Soumik Saha",
			"Hire Soumik Saha",
			"Software Engineer Contact",
			"Kolkata Developer",
		],
	},
];

export default SEO;
